<script lang="ts">
    import { getCustomer } from "../../../functions/CommerceAPIs/bigCommerce/customer"
    import { login } from "../../../store"
    import Addresses from "./account/Addresses.svelte"
    import PasswordChange from "./account/PasswordChange.svelte"
    import PersonalData from "./account/PersonalData.svelte"
</script>

<section class="small-wrapper">
    {#await getCustomer($login.tokenData.tibiId)}
        ...
    {:then customer}
        <div class="grid">
            <div class="item1">
                <PersonalData customer="{customer}" />
            </div>
            <div class="item2">
                <Addresses customer="{customer}" />
            </div>
            <div class="item3"><PasswordChange customer="{customer}" /></div>
        </div>
    {/await}
</section>

<style lang="less">
    @import "../../../assets/css/variables.less";
    .small-wrapper {
        flex-grow: 1;
        .grid {
            width: 100%;
            padding: 48px var(--horizontal-default-margin) 96px var(--horizontal-default-margin);
            display: grid;
            grid-template-columns: 1fr;
            @media @min-tablet {
                grid-template-columns: 1fr 1fr;
            }
            column-gap: 2.4rem;
            row-gap: 2.4rem;
            .item1 {
                width: 100%;
                grid-column: 1;
            }
            .item2 {
                grid-row-start: 1;
                grid-row-end: 3;
                grid-column: 2;
                @media @mobile {
                    grid-column: 1;
                }

                width: 100%;
                height: 100%;
            }
            .item3 {
                grid-column: 1;
                width: 100%;
            }
        }
    }
</style>
